import { FacebookIcon, InstagramIcon, LinkedIcon, TwitterIcon } from "Website/assets/images";
import appstore from 'Website/assets/images/appstore.png';
import googleplay from 'Website/assets/images/googleplay.png';
import SelectLanguage from 'Website/Language/Components/SelectLanguage';
import Menu from 'Website/Menu/Components/Menu';
import Logo from "./Logo";


const Footer = (props) => {
    return (
        <footer>
            <Logo />
            <div className='footer_nav_block margin-auto'>
                <Menu displayMenu={['PrivacyMenu', 'TermsMenu', 'ContactUsMenu', 'EnkripWebMenu']} />
                {/* <Menu displayMenu={['AboutMenu', 'PrivacyMenu', 'TermsMenu', 'ContactUsMenu', 'EnkripWebMenu', 'HelpMenu','PolicyMenu']} /> */}

                <div>
                    <p>2026 &copy; EN Connect</p>
                    {/* <SelectLanguage handleSetLanguage={props.handleSetLanguage} selectedLang={props.selectedLang} /> */}
                </div>
            </div>
            {/* <div className="social_block">
                <div>
                    <a href={process.env.REACT_APP_IOS_APP_URL} target="_blank"><img src={appstore} alt="App Store" title="App Store" className="lazy-img" /></a>
                    <a href={process.env.REACT_APP_ANDROID_APP_URL} target="_blank"><img src={googleplay} alt="Google Play" title="Google Play" className="lazy-img" /></a>
                </div>
                <div>
                    <a href={process.env.REACT_APP_SOCIAL_APP_URL} target="blank"><FacebookIcon /></a>
                    <a href={process.env.REACT_APP_SOCIAL_APP_URL} target="blank"><TwitterIcon /></a>
                    <a href={process.env.REACT_APP_SOCIAL_APP_URL} target="blank"><LinkedIcon /></a>
                    <a href={process.env.REACT_APP_SOCIAL_APP_URL} target="blank"><InstagramIcon /></a>
                </div>
            </div> */}
        </footer>
    )
}

export default Footer;